import { createAction, props } from '@ngrx/store';
import { FaqItem } from '../../models';

export const LoadFaq = createAction('[Category] Load Faq');
export const LoadFaqSuccess = createAction('[Category] Load Faq Success', props<{ faq: FaqItem[] }>());
export const LoadFaqFail = createAction('[Category] Load Faq Fail', props<{ error: any }>());

export const ClearFaq = createAction('[Category] Faq Clear ');
